<!--
  Both implementations inherit BaseCarouselComponent's required `slides` input.
  Neither drives its carousels from it, so pass the empty array they defaulted
  to while they were routed components directly.
-->
@if (isNewVersion) {
  <app-home-new [slides]="[]" />
} @else {
  <app-home [slides]="[]" />
}
